import React, { useEffect, useState } from 'react'
import PublicLayout from '../../layouts/PublicLayout'
import { getProgramList } from '../../services/program'
import { Box, Button, Container, Grid, Text, TextInput } from '@mantine/core'
import classes from './Template.module.css'
import SkeletonCard from '../../components/ui/SekeletonCard'
import TemplateCard from '../../components/pages/Program/TemplateCard'
import { HelmetProvider } from 'react-helmet-async'
import SEOPage from '../../components/seo/SEOPage'

const defaultParameter = {
  skip: 0,
  take: 8,
  search: '',
  order: 'asc',
  kind: 'template',
}

const Template = () => {
  const [params, setParams] = useState(defaultParameter)
  const [templateList, setTemplateList] = useState([])
  const [count, setCount] = useState(0)
  const [loading, setLoading] = useState(true)


  const handleGetTemplateList = async () => {
    setLoading(true)
    try {
      const response = await getProgramList(params)
      setTemplateList(response.data)
      setCount(response.count)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    handleGetTemplateList()
    // eslint-disable-next-line
  }, [params])

  const handleSearchChange = (e) => {
    setParams({ ...params, [e.target.name]: e.target.value })
  }

  const handlePage = (params) => {
    if (templateList.length < count) {
      setParams({ ...params, 'take': params.take + 8 })
    }
  }

  const loadingData = (number) => Array.from({ length: number }, (_, i) => {
    return (
      <Grid.Col span={{base: 6, md: 6, lg: 3 }} key={i}>
        <SkeletonCard />
      </Grid.Col>
    )
  })

  const mappingDataTemplate = (data) => {
    if (data.length > 0) {
      const remap = data.map((val, index) => {
        return (
          <Grid.Col span={{base: 6, md: 6, lg: 3 }} key={index}>
            <TemplateCard data={val} />
          </Grid.Col>
        )
      })
      return remap
    } else {
      return (
        <Grid.Col span={12}>
          <Box ta='center' py={60}>
            <Text c="dark">Template yang anda cari belum tersedia</Text>
          </Box>
        </Grid.Col>
      )
    }
  }

  return (
    <HelmetProvider>
      <SEOPage title='Template - Laju Reaksi by Katalis Talenta Indonesia' />
      <PublicLayout>
        {/* <TrainingHeader handleScroll={() => scrollIntoView({alignment: 'center'})} /> */}
        <Box className={classes.trainingSection}>
          <Container fluid className={classes.section}>
            <Box>
              <Box className={classes.paddingPage}>
                <Text className={classes.titleHeader} fw="bold">Temukan Template yang kamu inginkan!</Text>
                <Text className={classes.captionHeader}>Template dari PT Katalis Talenta Indonesia</Text>
                <Box className={classes.searchTrainingBox}>
                  <Grid>
                    <Grid.Col span={{ base: 12, md: 3,lg: 3 }}>
                      <TextInput
                        placeholder="Cari Template. . ."
                        name="search"
                        onChange={handleSearchChange}
                      />
                    </Grid.Col>
                  </Grid>
                </Box>
              </Box>
              <Box mt="xl">
                <Grid gutter='xl' className={classes.gridProgramCard} align="center">
                  {loading ? loadingData(8) : mappingDataTemplate(templateList)}
                </Grid>
              </Box>
              <Box mt={30} align="center">
                {templateList.length < count ? (<Button loading={loading} color='red' onClick={() => handlePage(params)}>Selengkapnya</Button>) : ''}
              </Box>
            </Box>
          </Container>
        </Box>
      </PublicLayout>
    </HelmetProvider>
  )
}

export default Template